// Lib
import { clamp } from 'lodash';

// Utils
import { getMinScale } from './zoomScaleUtils';

// Constants
import { ZOOM_PROPS } from './zoomConstants';

// Types
import { RectSize } from '../../../common/maths/geometry/rect/rectTypes';

export const ZOOM_DIRECTIONS = {
    UNKNOWN: 'UNKNOWN',
    IN: 'IN',
    OUT: 'OUT',
};

/**
 * Determine the next scale to use based on the current zoom state and the change in gesture size.
 */
// FIXME handle zoom out on iPad
export const getZoomNextScaleOnTouch = (
    canvasViewportClientRect: DOMRect,
    canvasDocumentSize: RectSize,
    currentGestureSize: number,
    initialGestureSize: number,
    initialScale: number,
    zoomDirection: string,
) => {
    const minScale = getMinScale(canvasViewportClientRect, canvasDocumentSize);

    const ratioChange = currentGestureSize / initialGestureSize;

    let nextScale = clamp(initialScale * ratioChange, minScale, ZOOM_PROPS.MAX_SCALE);

    const clampTo100Percent =
        (nextScale > 1 && initialScale < 1) ||
        (nextScale < 1 && initialScale > 1) ||
        (initialScale === 1 && zoomDirection === ZOOM_DIRECTIONS.IN && nextScale < 1) ||
        (initialScale === 1 && zoomDirection === ZOOM_DIRECTIONS.OUT && nextScale > 1);

    // Force scales beyond 100% or less than 100% to occur in two distinct scales
    if (clampTo100Percent) {
        nextScale = 1;
    }

    return nextScale;
};
